import { Injectable } from '@angular/core';
import { NavigationBehaviorOptions, Params, Router } from '@angular/router';
import { WindowRef } from '@spartacus/core';

interface NavigateOptions extends NavigationBehaviorOptions {
  queryParams?: Params;
}

const PROTOCOL_REGEX = /^https?:\/\//i;
const VIBER_REGEX = /(?:viber)/gm;
const MAIL_REGEX = /^mailto:/i;
const TEL_REGEX = /^tel:/i;

@Injectable({ providedIn: 'root' })
export class UrlNavigatorService {
  constructor(
    private winRef: WindowRef,
    private router: Router,
  ) {}

  /**
   * Осуществляет навигацию по ссылке. Определяет относительную ссылку из абсолютной
   *
   * @param url относительная или абсолютная ссылка
   * @param options дополнительные параметры (если ссылка относительная или абсолютная с текущим origin)
   */
  navigate(url: string, options: NavigateOptions = {}): void {
    url = this.removeInternalPrefix(url);
    if (this.isExternal(url)) {
      this.winRef.location.href = url;

      return;
    }

    const { queryParams, ...extras } = options;
    if (queryParams) {
      url = this.appendQueryParams(url, queryParams);
    }

    this.router.navigateByUrl(url, extras);
  }

  /**
   * Удаляет origin у асолютной ссылки, если тот есть
   */
  removeInternalPrefix(url: string): string {
    for (const prefix of this.getInternalPrefixes()) {
      if (url.startsWith(prefix)) {
        return url.slice(prefix.length);
      }
    }

    return url;
  }

  /**
   * Проверяет ссылку, внутренняя или абсолютная
   */
  isExternal(url: string): boolean {
    return PROTOCOL_REGEX.test(url) || VIBER_REGEX.test(url) || MAIL_REGEX.test(url) || TEL_REGEX.test(url);
  }

  private getInternalPrefixes(): string[] {
    const out = ['https://www.sdvor.com', 'https://sdvor.com'];

    if (this.winRef.location.origin) {
      out.push(this.winRef.location.origin);
    }

    return out;
  }

  private appendQueryParams(path: string, params: Params): string {
    const [pathWithoutQuery, queryString] = path.split('?', 2);
    const query = new URLSearchParams(queryString);
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        query.append(key, value);
      }
    });
    const newQueryString = query.toString();

    return newQueryString ? pathWithoutQuery + '?' + newQueryString : pathWithoutQuery;
  }
}
